// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select__Select--3gDog"};